export default {
	"activate.Expired": "Expired",
	"activate.HasBeenEffective": "Has been effective",
	"activate.NotInEffect": "Not in effect",
	"activate.all": "all",
	"activate.LoggedOut": "Logged out",
	"activate.NotRedeemed": "Not redeemed",
	"activate.Redeemed": "Redeemed",
	"activate.CopiedSuccessfully": "Copied successfully!",
	"activate.ReplicationIsNotSupported": "Replication is not supported",
	"activate.TheUserDoesNotHaveActivationCodeData": "The user does not have activation code data",
	"activate.ParameterError": "Parameter error!",
	"activate.TheVerificationCodeHasExpiredPleaseGetTheVerificationCodeAgain": "The verification code has expired, please get the verification code again",
	"activate.TheUsersMobilePhoneNumber": "The user's mobile phone number",
	"activate.ActivationCode": "Activation code",
	"activate.copy": "copy",
	"activate.RedemptionStatus": "Redemption status",
	"activate.EffectiveStatus": "Effective status",
	"activate.TheOrderNumber": "The order number",
	"activate.RedeemGoods": "Redeem goods",
	"activate.RedemptionAddress": "Redemption address"
}